import { render, staticRenderFns } from "./HeaderWithHelpButton.vue?vue&type=template&id=c3872e1e&scoped=true&"
import script from "./HeaderWithHelpButton.vue?vue&type=script&lang=js&"
export * from "./HeaderWithHelpButton.vue?vue&type=script&lang=js&"
import style0 from "./HeaderWithHelpButton.vue?vue&type=style&index=0&id=c3872e1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3872e1e",
  null
  
)

export default component.exports